import React from "react"
import Img from "gatsby-image"

import { Wrapper, CardBody } from "./styles"

const Card = ({ image, children, background }) => (
  <Wrapper flexDirection="column">
    {image && <Img fluid={image} style={{ marginBottom: 0 }} />}
    <CardBody flexDirection="column" flex="1 1 auto" background={background}>
      {children}
    </CardBody>
  </Wrapper>
)

export default Card
